<h5 mat-dialog-title>{{ 'Adp-Schedules-Add' | translate: {Default: "Adp Schedule"} }}</h5>

<mat-dialog-content>
    <ng-container *ngIf="!loadingTimezones; else loading">
        <form class="form" [formGroup]="form">
            <mat-form-field appearance="fill">
                <mat-label>{{ 'Adp-Schedules-Hour' | translate: {Default: "Hour"} }}</mat-label>
                <mat-select disableOptionCentering formControlName="hour">
                    <mat-option *ngFor="let hour of hours" [value]="hour">
                        {{ hour.toString().padStart(2, '0') }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>{{ 'Adp-Schedules-Minute' | translate: {Default: "Minute"} }}</mat-label>
                <mat-select disableOptionCentering formControlName="minute">
                    <mat-option *ngFor="let minute of minutes" [value]="minute">
                        {{ minute.toString().padStart(2, '0') }}
                    </mat-option>
                </mat-select>
            </mat-form-field>

            <mat-form-field appearance="fill">
                <mat-label>{{ 'Adp-Schedules-Timezone' | translate: {Default: "Timezone"} }}</mat-label>
                <mat-select disableOptionCentering formControlName="timezoneId">
                    <mat-option *ngFor="let timezone of timezones" [value]="timezone.id">
                        {{ timezone.displayName }}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </form>
    </ng-container>

    <ng-template #loading>
        <ngx-skeleton-loader count="3" [theme]="{ 'height.px': 50 }"></ngx-skeleton-loader>
    </ng-template>
</mat-dialog-content>

<mat-dialog-actions>
    <button class="mat-raised-button" appPreventDoubleClick (throttledClick)="close()">{{ 'Close' | translate: {Default: "Close"} }}</button>
    <button mat-raised-button setColor="primaryColour" color="primary" appPreventDoubleClick (throttledClick)="save()" [disabled]="!form.valid" *ngIf="form">{{ 'Save' | translate: {Default: "Save"} }}</button>
</mat-dialog-actions>
